/// Menu
import Metismenu from "metismenujs";
import React, { Component, useContext, useEffect } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";
import useScrollPosition from "use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import logo from "../../../images/logo.png";
import buildingImage from "../../../images/building.png";
import tabletImage from "../../../images/tablet.png";
import coinsImage from "../../../images/coins.png";
import shieldImage from "../../../images/shield.png";
import farmsImage from "../../../images/farms.png";
/// Image
//import profile from "../../../images/profile/pic1.jpg";
//import plus from "../../../images/plus.png";

class MM extends Component {
	  componentDidMount() {
		this.$el = this.el;
		this.mm = new Metismenu(this.$el);
	  }
	  componentWillUnmount() {
	  }
	render() {
		return (
			<div className="mm-wrapper">
				<ul className="metismenu" ref={(el) => (this.el = el)}>
					{this.props.children}
				</ul>
			</div>
		);
	}
}

const SideBar = () => {
  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
  } = useContext(ThemeContext);
  useEffect(() => {
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");
    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);
	
  }, []);
  let scrollPosition = useScrollPosition();
  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  /// Active menu
  let deshBoard = [
      "",
      "dashboard-dark",
      "order-list",
      "customer-list",
      "analytics",
      "reviews",
      "task",
    ],
    app = [
      "app-profile",
      "post-details",
      "app-calender",
      "email-compose",
      "email-inbox",
      "email-read",
      "ecom-product-grid",
      "ecom-product-list",
      "ecom-product-order",
      "ecom-checkout",
      "ecom-invoice",
      "ecom-customers",
      "post-details",
      "ecom-product-detail",
    ],
    email = ["email-compose", "email-inbox", "email-read"],
    shop = [
      "ecom-product-grid",
      "ecom-product-list",
      "ecom-product-list",
      "ecom-product-order",
      "ecom-checkout",
      "ecom-invoice",
      "ecom-customers",
      "ecom-product-detail",
    ],
    charts = [
      "chart-rechart",
      "chart-flot",
      "chart-chartjs",
      "chart-chartist",
      "chart-sparkline",
      "chart-apexchart",
    ],
    bootstrap = [
      "ui-accordion",
      "ui-badge",
      "ui-alert",
      "ui-button",
      "ui-modal",
      "ui-button-group",
      "ui-list-group",
      "ui-media-object",
      "ui-card",
      "ui-carousel",
      "ui-dropdown",
      "ui-popover",
      "ui-progressbar",
      "ui-tab",
      "ui-typography",
      "ui-pagination",
      "ui-grid",
    ],
    plugins = [
      "uc-select2",
      "uc-nestable",
      "uc-sweetalert",
      "uc-toastr",
      "uc-noui-slider",
      "map-jqvmap",
      "uc-lightgallery",
    ],
	redux = [
       "redux-form",
	   "redux-wizard",    
       "todo",
    ],
    widget = ["widget-basic"],
    forms = [
      "form-element",
      "form-wizard",
      "form-editor-summernote",
      "form-pickers",
      "form-validation-jquery",
    ],
    table = ["table-bootstrap-basic", "table-datatable-basic"],
    pages = [
      "page-register",
      "page-login",
      "page-lock-screen",
      "page-error-400",
      "page-error-403",
      "page-error-404",
      "page-error-500",
      "page-error-503",
    ],
    error = [
      "page-error-400",
      "page-error-403",
      "page-error-404",
      "page-error-500",
      "page-error-503",
    ];
  return (
    <div
      className={`deznav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? scrollPosition > 120
            ? "fixed"
            : ""
          : ""
      }`}
      style={{backgroundColor:"#1D4B3F"}}
    >
      <PerfectScrollbar className="deznav-scroll">
        <MM className="metismenu" id="menu">
          <li className={`${deshBoard.includes(path) ? "mm-active" : ""}`} style={{}}>
            <Link className="has-arrow ai-icon" to="../" >
            <i className="flaticon-381-pencil" aria-hidden="true"></i>

              <span className="nav-text" style={{fontSize:"14px",color:""}}>Paper AI</span>
            </Link>
          </li>

          <li className={`${path=="swap" ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="/swap" >
            <i className="flaticon-381-repeat-1" ></i>
              <span className="nav-text" style={{fontSize:"14px",color:""}}>Swap</span>
            </Link>
          </li>
          {/*
          --menu disabled--
          <li className={`${path=="fractals" ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="/fractals" >
            <img src={tabletImage} style={{width:"50px"}}/>
              <span className="nav-text" style={{fontSize:"14px",color:"#dc3545"}}>Fractals(Old)</span>
            </Link>
    </li>*/}

          <li className={`${path=="bridge" ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="/bridge" >
            <i className="flaticon-381-background" ></i>
              <span className="nav-text" style={{fontSize:"14px",color:""}}>Bridge</span>
            </Link>
          </li>

          <li className={`${path=="whitelist" ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="/whitelist" >
            <i className="flaticon-381-list" ></i>
              <span className="nav-text" style={{fontSize:"14px",color:""}}>Whitelist</span>
            </Link>
          </li>

          <li className={`${path=="airdrop" ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="/airdrop" >
            <i className="flaticon-381-send-1" ></i>
              <span className="nav-text" style={{fontSize:"14px",color:""}}>Airdrop</span>
            </Link>
          </li>

        </MM>
	
		<div className="copyright">
		
		</div>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
